import React from 'react';
import { Link } from '../../../../../../../../Router';
import { routes } from '../../../../../../routes';
import { FeedbackProps } from '../../../../types';

type PerformanceReviewLinkProps = {
  feedback: FeedbackProps;
  className?: string;
};

export const PerformanceReviewLink: React.FC<
  React.PropsWithChildren<PerformanceReviewLinkProps>
> = ({ feedback, className, children }) =>
  feedback.outcome?.flair__Ended_At__c ? (
    <Link
      to={routes.performanceReviewerPreviousReviews.route}
      feedbackId={feedback.Id}
      className={className}>
      {children}
    </Link>
  ) : (
    <Link
      to={routes.performanceReviewerEvaluate.route}
      feedbackId={feedback.Id}
      className={className}>
      {children}
    </Link>
  );
